import { Component, Input } from '@angular/core';

@Component({
  selector: 'base-sign-contract-error-status-tooltip',
  templateUrl: './base-sign-contract-error-status-tooltip.component.html',
})
export class BaseSignContractErrorStatusTooltipComponent {
  @Input({ required: true }) title: string;
  @Input({ required: true }) signedBy: string;
  @Input({ required: true }) signedAt: string;
}
